module.exports = __webpack_public_path__ + "img/8.0a2f7ae4.jpg";